import {StrictMode} from 'react'
import {init as initSentry} from '@sentry/react'
import {createRoot} from 'react-dom/client'

import {initI18n} from '@sdox/locale'
import {getSentryBrowserOptions} from '@sdox/utils/dom'

import {AppWithRouter} from './AppRouter'
import {SENTRY_DSN, SENTRY_PROJ_NR} from './constants'

import '@sdox/ui/styles'

initSentry({
  ...getSentryBrowserOptions(SENTRY_DSN, SENTRY_PROJ_NR, false),
  tracesSampleRate: 0,
  autoSessionTracking: false,
})
initI18n({defaultNS: ['eufe']})

const root = createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <StrictMode>
    <AppWithRouter />
  </StrictMode>,
)
